import { useDispatch } from "react-redux";

/**
 * @description This simple component is for future redux updates
 *  so we change the call of dispatch function here only
 * @returns the default dispatcher.
 */

const useAppDispatch = () => {
  const dispatch = useDispatch();
  return dispatch;
};

export default useAppDispatch;
